/*
  IE11 doesn't set the stack property on an Error object until after the error
  is thrown. This causes issues for code that assumes the property is set and
  has a string value. To fix, we set the default stack value to an empty string.
*/
if (navigator.userAgent.match(/Trident\/7\./)) {
  // eslint-disable-next-line no-extend-native
  Error.prototype.stack = '';
}
